<template>
  <div class="navtab">
    <div class="navtab__box">
      <p class="navtab__box--title">
        About us
      </p>
      <div v-for="aboutus in aboutusLinks" :key="aboutus.id">
        <app-link :id="aboutus.linkId" :type="aboutus.linkType" class="navtab__box--list link-unstyle">
          {{ aboutus.name }}
        </app-link>
      </div>
    </div>
    <div class="navtab__box" />

    <div class="navtab__box image">
      <img src="../../../assets/img/src/navbar/aboutUs-tab/featured-image.jpg" class="lazyload" width="432" height="359" alt="About Us Featured Image">
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      aboutusLinks: [
        {
          id: 1,
          name: 'Our story',
          linkType: 'page',
          linkId: 47,
        },
        {
          id: 2,
          name: 'Why travel with us',
          linkType: 'page',
          linkId: 64,
        },
        {
          id: 3,
          name: 'Client reviews',
          linkType: 'page',
          linkId: 96,
        },
        {
          id: 4,
          name: 'How to book',
          linkType: 'page',
          linkId: 44,
        },
        {
          id: 5,
          name: 'Make an enquiry',
          linkType: 'page',
          linkId: 43,
        },
        {
          id: 6,
          name: 'Contact us',
          linkType: 'page',
          linkId: 46,
        },
        {
          id: 7,
          name: 'A responsible company',
          linkType: 'page',
          linkId: 1241,
        },
        {
          id: 8,
          name: 'LGBTQ friendly holidays',
          linkType: 'page',
          linkId: 842,
        },
        {
          id: 9,
          name: 'FAQ',
          linkType: 'page',
          linkId: 49,
        },
      ],
    };
  },
  computed: {
    // isSearchTouched() {
    //   return this.$store.getters.getSearchTouch;
    // },
  },
  methods: {
    getAppLinkByID(pageID, ptype) {
      return this.$store.getters['applinks/getLink'](ptype, pageID).url;
    },
  },
};
</script>
